export const SET_FORM_FIELD = 'SET_FORM_FIELD';
export const BLUR_FORM_FIELD = 'BLUR_FORM_FIELD';
export const RESET_FORM = 'RESET_FORM';
